<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ caption }}</span>
    </p>
    <div style="position: relative;">
      <TableWrapper
        :columns="columns"
        :offset-height="offsetHeight"
        :mod-count="modCount"
        :url="url"
        :show-add="false"
        :pager="false"
        :border="false"
      />
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
import TableWrapper from '@/components/table-wrapper'
export default {
  name: 'VehicleRelationDialog',
  components: {
    TableWrapper
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      loadingStatus: false,
      modal: true,
      submit: false,
      url: this.action,
      modCount: 0
    }
  },
  computed: {
    offsetHeight() {
      return 480
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    },
    columns() {
      return [
        { title: '序号', type: 'index', width: 80, align: 'center' },
        { title: '用户', align: 'center', key: 'memberName', sortable: true, ellipsis: true, tooltip: true },
        { title: '手机号', align: 'center', key: 'mobile', sortable: true, ellipsis: true, tooltip: true },
        { title: '类型', align: 'center', key: 'ownerFlag', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {}, params.row.ownerFlag === 1 ? '车主' : '其他')
          }
        },
        { title: '同步时间', align: 'center', key: 'syncTime', sortable: true, width: 160, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {},
              params.row.activeStatus === 1 &&
              params.row.syncStatus === 1 &&
              params.row.syncTime ? params.row.syncTime : '---')
          }
        },
        { title: '同步状态', align: 'center', key: 'syncStatus', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { color: params.row.syncStatus === 1 && params.row.activeStatus === 1 ? 'green' : 'red' }
            }, params.row.syncStatus === 1 && params.row.activeStatus === 1 ? '已同步' : '未同步')
          }
        },
        { title: '操作', align: 'center',
          render: (h, params) => {
            return h('a', {
              style: {
                color: params.row.syncStatus !== 1 && params.row.activeStatus === 1 ? '#126D91' : '#9c9c9c',
                cursor: params.row.syncStatus !== 1 && params.row.activeStatus === 1 ? 'pointer' : 'not-allowed',
                marginRight: '10px'
              },
              on: {
                click: () => {
                  if (params.row.userId && params.row.syncStatus !== 1 && params.row.activeStatus === 1) {
                    this.showSyncModalDialog(params.row.id, params.row.memberName)
                  }
                }
              }
            }, [
              h('i', { class: { 'fas': true, 'fa-cloud-download-alt': true, 'cell-icon-link': true }}),
              h('span', {
                domProps: {
                  title: params.row.syncStatus !== 1 && params.row.activeStatus === 1 ? '同步用户车辆关系数据' : '数据已同步或车辆未激活'
                }
              }, '同步')
            ])
          }
        }
      ]
    }
  },
  watch: {
    showModal(val) {
      if (val) {
        this.url = this.action
      }
    }
  },
  methods: {
    showSyncModalDialog: function(relationId, memberName) {
      const _this = this
      this.$Modal.confirm({
        title: '确认同步用户车辆关系数据么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0', fontSize: '9pt' }}, [h('li', {}, memberName)])
        },
        onOk: function() {
          const _that = this
          request({
            url: this.$config.apiContextPath + '/sync/relation',
            method: 'POST',
            data: [relationId]
          }).then(res => {
            this.$Notice.success({
              title: '同步发送成功',
              desc: '用户车辆关系 `' + memberName + '` 同步请求成功发送!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据同步失败',
              desc: '用户车辆关系 `' + memberName + '` 同步失败, 错误信息: ' + error
            })
            _that.buttonLoading = false
          })
        }
      })
    },
    closeModal: function(changed = false) {
      this.url = ''
      this.$emit('on-close', changed)
    }
  }
}
</script>
